export default [
    {
        path: 'subject',
        name: '题库管理',
        icon: 'ios-albums-outline'
    },
    {
        path: 'pick',
        name: '获奖管理',
        icon: 'md-cube'
    },
    {
        path: 'config',
        name: '获奖配置',
        icon: 'ios-browsers'
    }
]